import { Link } from "react-router-dom";
import { FileText, Mail, MapPin, MessageCircle, Phone, ShieldAlert } from "lucide-react";
import { waLink } from "../lib/api";
import { LOGO_WIDE } from "./Header";

const CITIES = "Mumbai | Delhi | Bengaluru | Hyderabad | Chennai | Kolkata | Pune | Ahmedabad | Jaipur | Surat | Noida | Gurugram | Lucknow | Chandigarh | Indore | Bhopal | Bhubaneswar | Patna | Ranchi | Nagpur | Visakhapatnam | Kochi | Coimbatore | Vadodara | Nashik | Kanpur | Agra | Meerut | Goa";

export default function Footer() {
  return (
    <footer className="mt-20 border-t bg-slate-900 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="inline-flex items-center rounded-xl bg-white px-3 py-2">
              <img src={LOGO_WIDE} alt="Rent-ya-Buy.com" className="h-16 w-auto object-contain" />
            </div>
            <p className="mt-3 text-sm text-slate-400">
              Pan-India property marketplace. Rent It. Buy It. Own It.
            </p>
            <p className="mt-4 font-price text-xs text-slate-500">{CITIES}</p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Marketplace</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link data-testid="footer-rent" to="/properties?mode=rent" className="hover:text-white">Rent Property</Link></li>
              <li><Link data-testid="footer-buy" to="/properties?mode=buy" className="hover:text-white">Buy Property</Link></li>
              <li><Link data-testid="footer-sale" to="/properties?mode=sale" className="hover:text-white">Property for Sale</Link></li>
              <li><Link data-testid="footer-post" to="/post-property" className="hover:text-white">Post Your Property</Link></li>
              <li><Link data-testid="footer-watch" to="/market-watch" className="hover:text-white">Market Watch</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Contact Us</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a data-testid="footer-whatsapp" href={waLink("Hi! I need assistance on Rent-ya-Buy.com")} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white">
                  <MessageCircle className="h-4 w-4 text-emerald-400" /> WhatsApp Support
                </a>
              </li>
              <li className="flex items-center gap-2" data-testid="footer-phone"><Phone className="h-4 w-4 text-emerald-400" /> +91-9348843331</li>
              <li className="flex items-center gap-2" data-testid="footer-email"><Mail className="h-4 w-4" /> kessbbs@gmail.com</li>
              <li className="flex items-center gap-2" data-testid="footer-address"><MapPin className="h-4 w-4" /> India - 754109</li>
              <li className="flex items-center gap-2" data-testid="footer-gst"><FileText className="h-4 w-4" /> GST No: 21HMQPM1053J1ZX</li>
            </ul>
          </div>
          <div>
            <h4 className="flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wider text-white">
              <ShieldAlert className="h-4 w-4 text-amber-400" /> Safe Property Search
            </h4>
            <p className="mt-3 text-xs leading-relaxed text-slate-400">
              Rent-ya-Buy.com is a marketplace platform. Verification badges indicate information has passed the platform's stated verification process. Users should independently verify ownership, title documents, approvals, encumbrances and all legal details before completing any property transaction.
            </p>
          </div>
        </div>
        <div className="mt-10 border-t border-slate-800 pt-6 text-center text-xs text-slate-500">
          <p>
            Created by{" "}
            <a data-testid="footer-created-by" href="https://webxcreator.com" target="_blank" rel="noreferrer" className="font-semibold text-blue-400 hover:text-blue-300">
              WEBXCREATOR.COM
            </a>{" "}
            · Powered by{" "}
            <a data-testid="footer-powered-by" href="https://kees-ai.com" target="_blank" rel="noreferrer" className="font-semibold text-emerald-400 hover:text-emerald-300">
              KEES-AI.COM
            </a>{" "}
            · All rights reserved · GST No: 21HMQPM1053J1ZX
          </p>
          <p className="mt-1">© 2026 Rent-ya-Buy.com · One Platform. Every Property. Across India.</p>
        </div>
      </div>
    </footer>
  );
}
